module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "register textSection"
  }, [_c('h1', [_vm._v("Inscription")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getUser),
      expression: "!getUser"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('label', [_vm._v("Nom *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registerNom),
      expression: "registerNom"
    }],
    attrs: {
      "type": "text",
      "required": "required",
      "placeholder": "Nom"
    },
    domProps: {
      "value": (_vm.registerNom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerNom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Prenom *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registerPrenom),
      expression: "registerPrenom"
    }],
    attrs: {
      "type": "text",
      "required": "required",
      "placeholder": "Prenom"
    },
    domProps: {
      "value": (_vm.registerPrenom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerPrenom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "civilite"
    }
  }, [_vm._v("Civilité *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registerCivilite),
      expression: "registerCivilite"
    }],
    attrs: {
      "id": "civilite"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.registerCivilite = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "m"
    }
  }, [_vm._v("Homme")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "f"
    }
  }, [_vm._v("Femme")])]), _vm._v(" "), _c('label', [_vm._v("Adresse email *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registerEmail),
      expression: "registerEmail"
    }],
    attrs: {
      "type": "text",
      "required": "required",
      "placeholder": "name@example.com"
    },
    domProps: {
      "value": (_vm.registerEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerEmail = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.invalidEmail) ? _c('span', [_vm._v("Email invalide")]) : _vm._e(), _vm._v(" "), (_vm.emailAlreadyTaken) ? _c('span', [_vm._v("Email déjà utilisé")]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Mot de passe *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registerPassword),
      expression: "registerPassword"
    }],
    attrs: {
      "type": "password",
      "required": "required",
      "placeholder": "******"
    },
    domProps: {
      "value": (_vm.registerPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerPassword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.invalidPassword) ? _c('span', [_vm._v("\n                Le mot de passe doit :"), _c('br'), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Confirmer mot de passe *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registerConfirmation),
      expression: "registerConfirmation"
    }],
    attrs: {
      "type": "password",
      "required": "required",
      "placeholder": "******"
    },
    domProps: {
      "value": (_vm.registerConfirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerConfirmation = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.invalidConfirmation) ? _c('span', [_vm._v("La confirmation ne correspond pas au mot de passe")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("S'inscrire")]), _vm._v(" "), (_vm.registerMessage) ? _c('span', [_vm._v(_vm._s(_vm.registerMessage))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getUser),
      expression: "!getUser"
    }]
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Inscrivez-vous à la formation "), _c('br'), _c('em', [_vm._v("Savoir Être Aidant")]), _vm._v(" pour suivre le MOOC.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("contenir plus de 6 caractères")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Pourquoi s’inscrire sur "), _c('em', [_vm._v("Savoir Être Aidant")]), _vm._v(" ?")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Savoir Être Aidant")]), _vm._v(" est une formation en ligne, gratuite et ouverte à tous qui vous permettra d'aborder avec plus de sérénité votre rôle d'aidant. Conçue avec des experts du vieillissement et de l'aide, "), _c('em', [_vm._v("Savoir Être Aidant")]), _vm._v(" vous propose une formation s'adaptant à vous : ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('strong', [_vm._v("Niveau 1 :")]), _vm._v(" "), _c('em', [_vm._v("Savoir Être Aidant")]), _vm._v(", c'est avant tout un libre accès à l'ensemble des\n                vidéos traitant des multiples enjeux du vieillissement et de la place des aidants pour chacun d'entre\n                eux.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Niveau 2 :")]), _vm._v(" En vous inscrivant sur le site "), _c('em', [_vm._v("Savoir Être Aidant")]), _vm._v(", vous disposerez de\n                contenus supplémentaires (fiches pratiques, conseils, sites partenaires...) qui vous offriront la possibilité\n                de vous renseigner plus largement sur chacun de ces enjeux. ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Niveau 3 :")]), _vm._v(" Une fois inscrit, vous pourrez alors démarrer la formation qui en plus des vidéos\n                et des contenus supplémentaires, vous offrira la possibilité de tester votre compréhension des besoins\n                de votre proche et de votre rôle. A l’issue de la formation, vous pourrez alors obtenir une certification.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-109701fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = 439
// module chunks = 1